import i18next from 'i18next';
import en from './locales/en.json';
import de from './locales/de.json';
import hu from './locales/hu.json';
import fr from './locales/fr.json';

export const ns = 'sales';

let registered = false;

export function registerTranslations() {
  if (registered) return;
  registered = true;
  i18next.addResourceBundle('en', ns, en, true, true);
  i18next.addResourceBundle('de', ns, de, true, true);
  i18next.addResourceBundle('hu', ns, hu, true, true);
  i18next.addResourceBundle('fr', ns, fr, true, true);
}
